import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonType } from 'react-magma-dom';

import * as types from './types';

import RadioButton from 'components/RadioButton';

class ContentComponent extends React.PureComponent {
  static propTypes = {
    errorOccured: PropTypes.bool.isRequired,
    selectedType: PropTypes.string.isRequired,

    onTypeChange: PropTypes.func.isRequired,
    onDownloadButtonClick: PropTypes.func.isRequired
  }

  render () {
    return (
      <div>
        {this.props.errorOccured &&
          <div className="text-center mt-15">
            <div>An error occured while creating the selected file type.</div>
            <div>Please try one of the other available extensions instead.</div>
          </div>
        }

        <div className="main-modal__body">
          <p className="font-14 opacity-50">
            Download as
          </p>

          <div className="mb-30">
            {map(types, (description, type) =>
              <RadioButton
                key={type}
                value={type}
                name="download"
                labelClassName="mb-10 mr-30"
                onChange={this.props.onTypeChange}
                checked={type === this.props.selectedType}
              >

                <span className="font-700">.{type}</span> file {description}
              </RadioButton>
            )}
          </div>

          <div className="text-center">
            <Button
              style={{ fontSize: '14px' }}
              type={ButtonType.button}
              onClick={this.props.onDownloadButtonClick}
            >
              Download
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ContentComponent;
